export default __webpack_public_path__ + "static/media/settings.3f661e76.svg";